export const FETCH_PERSON_EMPLOYMENTS_END = "setPersonEmploymentsList";
export const FETCH_PERSONNEL_EMPLOYMENTS_END = "setPersonnelEmploymentsList";
export const LOAD_PERSON_EMPLOYMENT_TO_EDIT = "loadPersonEmploymentToEdit";
export const RESET_DEFAULT_NEW_PERSON_EMPLOYMENT = "resetDefaultNewPersonEmployment";
export const RESET_DEFAULT_NEW_PERSON_EMPLOYMENT_LIST = "resetDefaultNewPersonEmploymentList";
export const RESET_DEFAULT_PERSON_EMPLOYMENT_TO_EDIT = "resetDefaultPersonEmploymentToEdit";
export const TOGGLE_EDIT_PERSON_EMPLOYMENT_DIALOG = "toggleEditPersonEmploymentDialog";
export const TOGGLE_NEW_PERSON_EMPLOYMENT_DIALOG = "toggleAddPersonEmploymentDialog";
export const UPDATE_ADD_PERSON_EMPLOYMENT_FIELD = "updateAddPersonEmploymentField";
export const UPDATE_PERSON_EMPLOYMENT_FIELD = "updatePersonEmploymentToEdit";
